const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Admin Content Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('AdminContent', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {

  return $resource(appConfiguration.apiUrl + '/learn/v4/admin-content/:subresource/:type', null, {
    get: {params: {subresource: '',}, method: 'GET', isArray: false},
    getAnalytics: {params: {subresource: '', type: 'analytics'}, method: 'GET', isArray: false},
    find: {params: {subresource: ''}, method: 'GET', isArray: false},
    findAnalytics: {params: {subresource: 'analytics'}, method: 'GET', isArray: false}
  });

}]);
